import { NavLink } from 'react-router-dom'
import c from './styles.module.scss'
import { priceFormate } from '../../utils/price'
import { quantityFormate } from '../../utils/quantity'
import { IMAGE_URL } from '../../http'

const ProductsListItem = ({data}) => {
    const {price, quantity, product} = data
    const {id, image, name} = product

    return (
        <div className={c.item}>
            <NavLink end to={'/products/' + id} className={c.name}>
                <div className={c.image}>{image ? <img src={IMAGE_URL + image} alt={name}/> : <div className={[c.icon, 'icon-image'].join(' ')}></div>}</div>
                <div className={c.text}>
                    <div className={c.title}>{name}</div>
                    <div className={c.label}>Цена за ед: {priceFormate(price)}</div>
                </div>
            </NavLink>
            <div className={c.quantity}>
                <div className={c.title}>{quantityFormate(quantity)}</div>
                <div className={c.label}>Кол-во</div>
            </div>
            <div className={c.price}>
                <div className={c.title}>{priceFormate(price * quantity)}</div>
                <div className={c.label}>Стоимость</div>
            </div>
        </div>
    )
}

const ProductsList = ({items}) => {
    return (
        <div className={c.list}>
            {items.map(item => <ProductsListItem key={item.id} data={item}/>)}
        </div>
    )
}

export default ProductsList